import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

export default function NewsletterForm() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const onSubmit = (e) => {
    e.preventDefault();
    setError("");
    if (!name.trim() || !email.trim()) {
      setError(t("newsletter.errorRequired"));
      return;
    }
    if (!emailRegex.test(email.trim())) {
      setError(t("newsletter.errorEmail"));
      return;
    }
    setSubmitting(true);
    // No backend — persist locally and redirect to Spanish thank_you.
    try {
      const existing = JSON.parse(localStorage.getItem("caporive-leads") || "[]");
      existing.push({ name: name.trim(), email: email.trim(), ts: new Date().toISOString() });
      localStorage.setItem("caporive-leads", JSON.stringify(existing));
    } catch (err) {
      // localStorage unavailable — proceed with redirect regardless
    }
    navigate("/thank_you");
  };

  return (
    <form
      onSubmit={onSubmit}
      data-testid="newsletter-form"
      className="w-full grid grid-cols-1 gap-4"
      noValidate
    >
      <div>
        <label
          htmlFor="nl-name"
          className="block text-xs uppercase tracking-widest text-[#0D1B2A]/70 mb-2 font-semibold"
        >
          {t("newsletter.nameLabel")}
        </label>
        <input
          id="nl-name"
          name="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={t("newsletter.namePlaceholder")}
          data-testid="newsletter-name-input"
          className="w-full h-12 px-4 border border-[#0D1B2A]/25 bg-white text-[#0D1B2A] focus:outline-none focus:border-[#D4AF37]"
          required
        />
      </div>
      <div>
        <label
          htmlFor="nl-email"
          className="block text-xs uppercase tracking-widest text-[#0D1B2A]/70 mb-2 font-semibold"
        >
          {t("newsletter.emailLabel")}
        </label>
        <input
          id="nl-email"
          name="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t("newsletter.emailPlaceholder")}
          data-testid="newsletter-email-input"
          className="w-full h-12 px-4 border border-[#0D1B2A]/25 bg-white text-[#0D1B2A] focus:outline-none focus:border-[#D4AF37]"
          required
        />
      </div>

      {error && (
        <p
          role="alert"
          data-testid="newsletter-error"
          className="text-sm text-red-700 bg-red-50 border border-red-200 px-3 py-2"
        >
          {error}
        </p>
      )}

      <button
        type="submit"
        data-testid="newsletter-submit"
        disabled={submitting}
        className="h-12 px-8 bg-[#0D1B2A] text-white text-xs uppercase tracking-widest font-semibold hover:bg-[#1B263B] disabled:opacity-70"
      >
        {submitting ? t("newsletter.submitting") : t("newsletter.submit")}
      </button>

      <p className="text-xs text-[#0D1B2A]/60 leading-relaxed">
        {t("newsletter.consent")}
      </p>
    </form>
  );
}
